import { MdDelete, MdEdit, MdOutlinePreview } from "react-icons/md";
import { QuestionAnalysis } from "../models/QuestionAnalysis";
import "./questionlistcomponent.css";
import {
  Button,
  Center,
  Group,
  Loader,
  ScrollArea,
  Stack,
  Text,
  Title,
} from "@mantine/core";

interface QuestionListComponentProps {
  loading: boolean;
  questionAnalysisList: QuestionAnalysis[];
  handleEdit: (analysis: QuestionAnalysis) => void;
  setItemToDelete: (newValue: QuestionAnalysis) => void;
  setShowDeleteModal: (newValue: boolean) => void;
  interviewSubmitted: boolean;
}

const QuestionListComponent = ({
  loading,
  questionAnalysisList,
  handleEdit,
  setItemToDelete,
  setShowDeleteModal,
  interviewSubmitted,
}: QuestionListComponentProps) => {
  return (
    <Stack h={450}>
      <Title order={4}>Added Questions:</Title>
      <ScrollArea>
        {loading ? (
          <Center>
            <Loader size="md" mt="xl" />
          </Center>
        ) : (
          questionAnalysisList.map((questionAnalysis) => (
            <Group key={questionAnalysis.questionNum} gap="xs" mb="xs">
              <Button
                size="compact-sm"
                onClick={() => handleEdit(questionAnalysis)}
              >
                {interviewSubmitted ? <MdOutlinePreview /> : <MdEdit />}
              </Button>
              {!interviewSubmitted && (
                <Button
                  size="compact-sm"
                  bg="red"
                  onClick={() => {
                    setItemToDelete(questionAnalysis);
                    setShowDeleteModal(true);
                  }}
                >
                  <MdDelete />
                </Button>
              )}
              <Title order={4}>
                {questionAnalysis.questionNum}
                {". "}
              </Title>
              <Text>{questionAnalysis.question}</Text>
            </Group>
          ))
        )}
      </ScrollArea>
    </Stack>
  );
};

export default QuestionListComponent;
